import React, { useEffect, useState } from "react";
import { Alert, Card, Col, Form, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { ReactSortable } from "react-sortablejs";
import {
  editPeriodConfig,
  getPeriodConfig,
  savePeriodConfig,
} from "../../redux/evaluacion_desempenio/PeriodConfig/actions";
import moment from "moment";
import toastr from "toastr";

const Period = (props) => {
  const [actualizoIndex, setActualizoIndex] = useState(false);
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [loaderDate, setLoaderDate] = useState(false);
  const [errorPeriod, setErrorPeriod] = useState("");
  const [formError, setFormError] = useState("");
  const [opcionesT, setOpcionesT] = useState([]);
  const [timer, setTimer] = useState(null);
  const [dragValue, setDragValue] = useState(null);
  const [dateSelected, setDateSelected] = useState("");
  const [isDateSelected, setIsDateSelected] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    if (props.isSubmit) {
      dispatch(
        savePeriodConfig(
          opcionesT,
          setOpcionesT,
          setSaveLoader,
          setErrorPeriod,
          setFormError,
          props,
          dateSelected,
          setDateSelected
        )
      );
    }
  }, [props.isSubmit]);

  useEffect(() => {
    if (
      opcionesT.length > 0 &&
      opcionesT[0].id !== 0 &&
      opcionesT[0].fecha_llenado
    ) {
      setDateSelected(opcionesT[0].fecha_llenado);
    } else if (
      opcionesT.length > 0 &&
      opcionesT[0].id !== 0 &&
      opcionesT[0].fecha_fin
    ) {
      setDateSelected(
        `${moment(opcionesT[0].fecha_fin).format("YYYY")}-${moment(
          opcionesT[0].fecha_fin
        ).format("MM")}-${moment(opcionesT[0].fecha_fin).format("DD") - 15}`
      );
    } else {
      setDateSelected("");
    }
  }, [opcionesT]);

  useEffect(() => {
    if (props.isDateChange) {
      setIsDateSelected(true);
      if (dateSelected !== "") {
        if (moment(dateSelected) < moment(opcionesT[0].fecha_inicio)) {
          toastr.info(
            `La fecha ingresada no puede ser antes de la fecha inicio de periodo: ${moment(
              opcionesT[0].fecha_inicio
            ).format("DD/MM/YYYY")}`
          );
        } else if (moment(dateSelected) > moment(opcionesT[0].fecha_fin)) {
          toastr.info(
            `La fecha ingresada no puede ser despues de la fecha fin de periodo: ${moment(
              opcionesT[0].fecha_fin
            ).format("DD/MM/YYYY")}`
          );
        } else {
          dispatch(
            editPeriodConfig(
              opcionesT,
              setLoaderDate,
              setFormError,
              dateSelected
            )
          );
        }
      } else {
        toastr.info(`Debe seleccionar una fecha valida`);
      }
      if (timer) {
        clearTimeout(timer);
        setTimer(null);
      }
      setTimer(
        setTimeout(() => {
          props.setIsDateChange(false);
        }, 1000)
      );
    }
  }, [props.isDateChange]);

  useEffect(() => {
    if (props.valorRequerido.length > 0) {
      setOpcionesT(props.valorRequerido);
    } else {
      setOpcionesT([{ id: 0, nombre: "No hay evaluación" }]);
    }
    if (props.periodicity && props.periodicity.id) {
      dispatch(
        getPeriodConfig(
          { tipo_busqueda: "periodicidad__id", filter: props.periodicity.id },
          setOpcionesT,
          setLoader,
          setFormError,
          setErrorPeriod,
          props.index + 1
        )
      );
    }
  }, []);

  useEffect(() => {
    if (actualizoIndex && dragValue && dragValue.requerido) {
      setOpcionesT(
        opcionesT
          .filter((opt) => opt.id !== 0)
          .sort((a, b) => {
            if (a.id && b.id) {
              if (a.id === b.id) {
                return 0;
              }
              if (a.id < b.id) {
                return -1;
              }
            }
            return 1;
          })
      );
      setActualizoIndex(false);
      setDragValue(null);
    }
    if (actualizoIndex && dragValue && !dragValue.requerido) {
      let valTemp = opcionesT.filter((opt) => opt.id !== 0);
      valTemp.push(dragValue);
      setOpcionesT(
        valTemp.sort((a, b) => {
          if (a.id && b.id) {
            if (a.id === b.id) {
              return 0;
            }
            if (a.id < b.id) {
              return -1;
            }
          }
          return 1;
        })
      );
      setActualizoIndex(false);
      setDragValue(null);
    }
    if (actualizoIndex && !dragValue) {
      setOpcionesT(
        opcionesT
          .filter((opt) => opt.id !== 0)
          .sort((a, b) => {
            if (a.id && b.id) {
              if (a.id === b.id) {
                return 0;
              }
              if (a.id < b.id) {
                return -1;
              }
            }
            return 1;
          })
      );
      setActualizoIndex(false);
      setDragValue(null);
    }
  }, [actualizoIndex]);

  return (
    <>
      {loader || saveLoader ? (
        <div className="d-flex justify-content-center">
          <Spinner
            animation="border"
            role="status"
            className="d-flex justify-content-center"
          />
        </div>
      ) : (
        <>
          <Col md="5" xs="auto" className="mx-auto">
            <Card
              className="mb-1 px-0 border border-muted rounded shadow-sm bg-white"
              style={{ border: "1px solid #ced4da" }}
            >
              <Card.Header className="card-crear text-muted d-flex flex-wrap justify-content-center align-items-center text-justify">
                <h6>Periodo {props.index + 1}</h6>
              </Card.Header>
              <Card.Body className="py-3 px-4 flex-wrap justify-content-between align-items-between text-justify">
                {errorPeriod === "" &&
                formError === "" &&
                opcionesT.length > 0 &&
                props.periodicity &&
                !props.periodicity.id ? (
                  <ReactSortable
                    tag="span"
                    list={opcionesT}
                    setList={setOpcionesT}
                    // onChange={(order, sortable, evt) => {
                    //   editPosicion(order, sortable, evt);
                    // }}
                    onAdd={(order, sortable, evt) => {
                      let dropValue = JSON.parse(order.item.dataset.value);
                      if (opcionesT.length > 0) {
                        opcionesT
                          .filter((item, _index) => item.id !== 0)
                          .map((item, index) => {
                            const temp = opcionesT.filter(
                              (opt) =>
                                opt.nombre === dropValue.nombre && opt.id !== 0
                            );
                            if (temp.length > 0) {
                              let optTemp = opcionesT;
                              optTemp = optTemp.filter(
                                (value) => dropValue.id !== value.id
                              );
                              if (dropValue.requerido) {
                                optTemp.push(dropValue);
                              }
                              setOpcionesT(
                                optTemp.sort((a, b) => {
                                  if (a.id && b.id) {
                                    if (a.id === b.id) {
                                      return 0;
                                    }
                                    if (a.id < b.id) {
                                      return -1;
                                    }
                                  }
                                  return 1;
                                })
                              );
                            }
                          });
                      }
                      setDragValue(dropValue);
                      setActualizoIndex(true);
                    }}
                    onRemove={(order, sortable, evt) => {
                      let tmp = opcionesT;
                      if (
                        opcionesT[parseInt(order.oldIndex)].requerido ===
                          true &&
                        props.valorRequerido.length > 0
                      ) {
                        tmp.push(props.valorRequerido[0]);
                      } else if (opcionesT.length === 1) {
                        tmp.push({ id: 0, nombre: "No hay evaluación" });
                      }
                      setOpcionesT(
                        tmp.sort((a, b) => {
                          if (a.id && b.id) {
                            if (a.id === b.id) {
                              return 0;
                            }
                            if (a.id < b.id) {
                              return -1;
                            }
                          }
                          return 1;
                        })
                      );
                      // setActualizoIndex(true);
                    }}
                    group={{
                      name: "list_evaluations",
                      pull:
                        props.periodicity && props.periodicity.id
                          ? false
                          : true,
                      put:
                        props.periodicity && props.periodicity.id
                          ? false
                          : true,
                    }}
                    sort={false}
                    animation={200}
                    // handle=".dragI"
                    delayOnTouchOnly={true}
                  >
                    {opcionesT.map((item, index) => (
                      <Col
                        md="12"
                        xs="auto"
                        className="py-2 px-3 mb-2 border border-muted rounded shadow-sm dragPeriod"
                        data-value={JSON.stringify(item)}
                      >
                        <div key={item.id}>{item.nombre}</div>
                      </Col>
                    ))}
                  </ReactSortable>
                ) : (
                  <>
                    {opcionesT.map((item) => (
                      <Col
                        md="12"
                        xs="auto"
                        className="py-2 px-3 mb-2 border border-muted rounded shadow-sm"
                      >
                        <div key={item.id}>{item.nombre}</div>
                      </Col>
                    ))}
                  </>
                )}
              </Card.Body>
            </Card>
            <Card
              className="mb-3 px-0 border border-muted rounded shadow-sm bg-white"
              style={{ border: "1px solid #ced4da" }}
            >
              <Card.Body className="py-2">
                <Form.Group as={Col} className="px-0 my-0">
                  <Form.Label column sm="12" md="12">
                    Fecha de evaluación:
                  </Form.Label>
                  <Form.Control
                    id="fecha_evaluacion"
                    name="fecha_evaluacion"
                    isInvalid={
                      (isDateSelected && dateSelected === "") ||
                      (isDateSelected &&
                        dateSelected !== "" &&
                        (moment(dateSelected) <
                          moment(opcionesT[0].fecha_inicio) ||
                          moment(dateSelected) >
                            moment(opcionesT[0].fecha_fin)))
                    }
                    isValid={
                      isDateSelected &&
                      dateSelected !== "" &&
                      !(
                        moment(dateSelected) <
                          moment(opcionesT[0].fecha_inicio) ||
                        moment(dateSelected) > moment(opcionesT[0].fecha_fin)
                      )
                    }
                    onChange={(e) => {
                      e.preventDefault();
                      var dateTemp = e.currentTarget.value;
                      if (timer) {
                        clearTimeout(timer);
                        setTimer(null);
                      }
                      setTimer(
                        setTimeout(() => {
                          setDateSelected(dateTemp);
                          setIsDateSelected(true);
                          if (
                            moment(dateTemp) < moment(opcionesT[0].fecha_inicio)
                          ) {
                            toastr.info(
                              `La fecha ingresada no puede ser antes de la fecha inicio de periodo: ${moment(
                                opcionesT[0].fecha_inicio
                              ).format("DD/MM/YYYY")}`
                            );
                          } else if (
                            moment(dateTemp) > moment(opcionesT[0].fecha_fin)
                          ) {
                            toastr.info(
                              `La fecha ingresada no puede ser despues de la fecha fin de periodo: ${moment(
                                opcionesT[0].fecha_fin
                              ).format("DD/MM/YYYY")}`
                            );
                          }
                          // else {
                          //   dispatch(
                          //     editPeriodConfig(
                          //       opcionesT,
                          //       setLoaderDate,
                          //       setFormError,
                          //       dateTemp
                          //     )
                          //   );
                          // }
                        }, 1200)
                      );
                    }}
                    defaultValue={dateSelected}
                    className="rounded-pill"
                    type="date"
                    disabled={
                      (props.periodicity && !props.periodicity.id) ||
                      opcionesT.length === 0 ||
                      (opcionesT.length > 0 && opcionesT[0].id === 0)
                    }
                  ></Form.Control>
                </Form.Group>
              </Card.Body>
            </Card>
          </Col>
          {props.periodos.length % 2 !== 0 &&
            props.periodos[props.index + 1] === undefined && (
              <Col md="5" xs="auto" className="mx-auto"></Col>
            )}
        </>
      )}
      {!!errorPeriod && (
        <Alert variant="danger" className="my-0">
          {errorPeriod}
        </Alert>
      )}
      {!!formError && (
        <Alert variant="danger" className="my-0">
          {formError}
        </Alert>
      )}
    </>
  );
};

export default Period;
